import React from 'react';

export default function RadioTabs({ name, options, value, onChange }) {
  return (
    <div className="radio-tabs">
      {options.map((opt) => (
        <label key={opt.value} className={`radio-option ${value === opt.value ? 'active' : ''}`}>
          <input
            type="radio"
            name={name}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
          />
          {opt.label}
        </label>
      ))}
    </div>
  );
}
